<script>
export default {
    name: 'panel-wrapper',
    props: 
    {
        menu: Array,
        isProgression: Boolean,
    },
    methods: 
    {
        goTo(slug)
        {
            this.$emit('switched')
            this.$router.push({ params: { slug: slug, page: 1}})
        }
    },
}
</script>
<template lang="html">
    <div class="panel-wrapper">
        <ul class="nav nav-tabs" :class="{'progressive': isProgression}">
            <li v-if="menu" v-for="(item, index) in menu" class="nav-item">
                <a class="nav-link cp" @click="goTo(item.slug)" :class="{'active': $route.params.slug == item.slug}">
                    {{ item.name }}
                    <i v-if="isProgression" :class="{'fal fa-circle' : !item.done, 'fas fa-check-circle text-blue' : item.done}"></i>
                </a>
            </li>
        </ul>
        <div class="panel-wrapper-content">
            <slot name="panel-wrapper-content"></slot>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/elements/panelWrapper.vue